@if (!props.disabled) {
  <quill-editor
    [formControl]="formControl"
    [classes]="'text-editor ' + (field.className || '')"
    [style.--text-editor-height]="props.height || '150px'"
    [modules]="props.modules"
    [formats]="props.formats"
    [required]="props.required"
    [debounceTime]="props.debounceTime || 300"
    [readOnly]="props.readonly"
    [placeholder]="props.placeholder || ''"
    (onContentChanged)="props.onChange?.($event)"
    (onFocus)="props.onFocus?.($event)"
    (onBlur)="props.onBlur?.($event)" />
} @else {
  <quill-view-html class="use-quill-view" [content]="formControl.value || ''" theme="snow" />
}
